import React, {useState} from "react";
import {Template} from "../../../components/template/template.jsx";
import {Card} from "../../../components/card/card.jsx";
import Button from "../../../components/button/button.jsx";
import InputForm from "../../../components/input/input-form.jsx";
import InputCheckbox from "../../../components/input/input-checkbox.jsx";
import SentryRow from "../../../components/template/sentry-row.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";
import {useQuery} from "@tanstack/react-query";
import projectUtils from "../../../utils/project-utils.js";
import FixedLocationInspectionService from "../../../services/dispatch/fixed-location-inspection-service.js";
import InputSwitch from "../../../components/input/input-switch.jsx";

const FixedLocationInspection = () => {
    const [state, setState] = useState({id: 1, items: []});
    const [isSaving, setIsSaving] = useState(false);

    const {isLoading, refetch} = useQuery({
        queryFn: () => FixedLocationInspectionService.get().then((data) => {
            setState({
                id: data?.id ?? 1,
                items: (data?.items ?? []).map(item => ({itemId: item.itemId ?? projectUtils.createTempKey(), item: item.item ?? "", active: !!item.active})),
            });
            return data;
        }),
        queryKey: ["dispatch-fixed-location-inspection"],
    });

    const addItem = () => setState(prev => ({...prev, items: [...prev.items, {itemId: projectUtils.createTempKey(), item: "", active: false}]}));

    const removeItem = (itemId) => setState(prev => ({...prev, items: prev.items.filter(item => item.itemId !== itemId)}));

    const updateItem = (itemId, value) => setState(prev => ({...prev, items: prev.items.map(item => item.itemId === itemId ? {...item, item: value} : item)}));

    const toggleActive = (itemId, active) => setState(prev => ({...prev, items: prev.items.map(item => item.itemId === itemId ? {...item, active} : item)}));

    const save = () => {
        const items = state.items
            .filter(item => (item.item ?? "").trim() !== "")
            .map(item => ({itemId: item.itemId, item: item.item, active: item.active}));

        const formData = new FormData();
        formData.append("items", JSON.stringify({id: state.id, items}));

        setIsSaving(true);
        FixedLocationInspectionService.save(state.id, formData)
            .then(() => {
                projectUtils.success(false);
                refetch();
            })
            .catch((error) => {
                console.error(error);
                const message = error.response?.data?.errorMessages ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", message, "Ok");
            })
            .finally(() => setIsSaving(false));
    };

    return (
        <Template isLoading={isLoading || isSaving}>
            <Template.Header>
                <Template.Title>Vistoria de posto fixo</Template.Title>
            </Template.Header>
            <Template.Body className="flex flex-col space-y-2">
                <Card>
                    <Card.Header>
                        <Card.Title>Itens</Card.Title>
                    </Card.Header>
                    <Card.Body className="flex flex-col gap-3">
                        {state.items.map(item => (
                            <SentryRow key={item.itemId}>
                                <InputForm classNameWrapper="col-span-9" id={`item-${item.itemId}`} label="Item" value={item.item}
                                           onChange={({target: {value}}) => updateItem(item.itemId, value)}/>
                                <div className="col-span-2 flex items-center">
                                    <InputSwitch
                                        id={`active-${item.itemId}`}
                                        label="Ativo"
                                        checked={item.active}
                                        onChange={(checked) => toggleActive(item.itemId, checked)}
                                    />
                                </div>
                                <div className="col-span-1 flex items-center justify-end">
                                    <Button target="danger" title="Remover item" onClick={() => removeItem(item.itemId)}><FaTrash/></Button>
                                </div>
                            </SentryRow>
                        ))}
                        {state.items.length === 0 &&
                            <span className="text-sm text-gray-400">Nenhum item cadastrado.</span>
                        }
                        <div>
                            <Button onClick={addItem}><FaPlus/>Adicionar item</Button>
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body className="flex justify-end">
                        <Button onClick={save} actionFeedbackType='save'>Salvar</Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default FixedLocationInspection;